import { Icon } from '@/components/Icon';
import { useState } from 'react';
import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  Path,
} from 'react-hook-form';
import { Platform, Pressable, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';
import { styles } from './styles';

type PasswordInputProps<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
> = {
  field: ControllerRenderProps<TFieldValues, TName>;
  fieldState: ControllerFieldState;
  placeholder?: string;
};

export const PasswordInput = <
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
>({
  field,
  fieldState,
  placeholder = 'Passwort',
}: PasswordInputProps<TFieldValues, TName>) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const { value, onChange, onBlur } = field;
  const { error } = fieldState;

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const borderColor = error ? theme.colors.red : theme.colors.primary;
  const iconColor = error ? theme.colors.red : theme.colors.primary;

  return (
    <View style={styles.wrapper}>
      <View style={[styles.inputRow, { borderColor }]}>
        <Icon name="key" size={28} color={iconColor} />
        <TextInput
          allowFontScaling={false}
          testID="password-input"
          style={[
            styles.textInput,
            Platform.OS === 'ios'
              ? {
                  lineHeight: 0,
                  color: theme.colors.newUI.therapist.textBlue100,
                }
              : { color: theme.colors.newUI.therapist.textBlue100 },
          ]}
          secureTextEntry={!showPassword}
          placeholder={placeholder}
          placeholderTextColor={theme.colors.twGrey}
          autoComplete="off"
          autoCapitalize="none"
          onBlur={onBlur}
          textBreakStrategy="simple"
          onChangeText={onChange}
          value={value}
        />
        <Pressable onPress={toggleShowPassword}>
          <Icon
            name={showPassword ? 'eye' : 'eyeOff'}
            size={28}
            color={theme.colors.primary}
          />
        </Pressable>
      </View>
      <View style={styles.errorRow}>
        <Text style={styles.errorText}>{error?.message}</Text>
      </View>
    </View>
  );
};
